module.exports = __webpack_public_path__ + "img/全部清洗.d803d9fa.svg";